import { render, staticRenderFns } from "./CustomerSupportTypesComponent.vue?vue&type=template&id=23aa4068"
import script from "./CustomerSupportTypesComponent.vue?vue&type=script&lang=js"
export * from "./CustomerSupportTypesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports